// Простое in-memory хранилище сессии Mini App: текущий запрос (источник+ник),
// загруженные партии и выбранная для разбора. Живёт на время сессии SPA.
import type { CoachGame } from '@ext/core/game-sources';
import type { GameSource } from './services/games';

export interface AppState {
  source: GameSource;
  nick: string;
  games: CoachGame[];
  selectedId: string | null;
  /** id партии, открытой по диплинку (чужой разбор) — включает CTA «разобрать свои». */
  sharedId: string | null;
  /** Куда вернуться из разбора локальной/публичной партии. */
  gameBackHash: string | null;
}

export const state: AppState = {
  source: 'auto',
  nick: '',
  games: [],
  selectedId: null,
  sharedId: null,
  gameBackHash: null,
};

export function setQuery(source: GameSource, nick: string): void {
  state.source = source;
  state.nick = nick;
  state.games = [];
  state.selectedId = null;
  state.sharedId = null;
  state.gameBackHash = null;
}

export function setGames(games: CoachGame[]): void {
  state.games = games;
}

export function selectGame(id: string): CoachGame | null {
  const game = state.games.find((g) => g.id === id) || null;
  state.selectedId = game ? id : null;
  return game;
}

export function selectedGame(): CoachGame | null {
  return state.games.find((g) => g.id === state.selectedId) || null;
}

/**
 * Положить PGN-партию как единственную в сессии и открыть её разбор. Вручную
 * вставленный PGN не считается чужим shared-разбором; серверный диплинк передаёт
 * shared=true. Оба возвращаются на стартовый экран.
 */
export function setPgnGame(game: CoachGame, shared = false): void {
  state.games = [game];
  state.selectedId = game.id;
  state.sharedId = shared ? game.id : null;
  state.gameBackHash = '#/';
}
